import {
    Feature,
    RoomChannelsEntityCommands,
    RoomChannelsEntityProperties,
} from '@vi-iot/client/index';

export namespace ReferenceRoomSettingsHelper {
  export enum ReferenceRoomSettingsView {
    NoRooms = 'noRooms',
    ManageRoom = 'manageRoom',
    AssignRoom = 'assignRoom',
  }

  export interface RoomsChannelsEntityData {
    featureIndex: string;
    feature: Feature<RoomChannelsEntityProperties, RoomChannelsEntityCommands>;
    channelId: string;
  }

  export const queryParamRoom = 'room';
}
